import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import PickUpTimeLayout from '../../containers/PickUpTime';
import Select from 'react-select';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import {clickOutsideConfig} from '../../helpers';
import RestaurantLayout from '../../containers/Restaurant';
import {DEFAULT_LANGUAGE} from '../../constants';

class ProductTypeView extends Component {
  constructor(props) {
    super(props);

    this.dealsMenu = 'deals';
    this.selectMenu = this.selectMenu.bind(this);
    this.getTypeName = this.getTypeName.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.checkIsActive = this.checkIsActive.bind(this);
    this.state = {
      selectedMenu: '',
    };
  }

  componentDidMount() {
    this.props.selectType(this.props.match.params.type);
  }

  onClick(event, name, callback) {
    callback(name);
    this.selectMenu('');
    this.props.selectCategory('all');
  };

  selectMenu(name) {
    const currentMenu = this.state.selectedMenu;
    this.setState({
      selectedMenu: currentMenu === name ? '' : name,
    });
  }

  getTypeName(typeName) {
    const {t, language} = this.props;
    if (typeName === this.dealsMenu) {
      return t('dealsTypeMenu');
    }
    const type = this.props.types.find(t => t.name === typeName);

    return type.id === 'pizza' ? t('pizzaTypeMenu') : type[`name_${language}`];
  }

  handleClickOutside(evt) {
    this.selectMenu('');
  };

  checkIsActive(type) {
    return this.props.match.params.type === type;
  }

  render() {
    const {t, selectedRestaurant, match, language} = this.props;
    const {selectedMenu} = this.state;
    const types = this.props.types;
    const lng = language || DEFAULT_LANGUAGE;
    return (
        <nav className="main-menu">
          <div className="main-menu__controls">
            <NavLink to="#"
               onClick={() => this.selectMenu('restaurant')}
               isActive={() => selectedMenu === 'restaurant'}
               className="main-menu__controls-column">
              <div className="main-menu__controls-title">
                <span className="text-uppercase">{t('takeAway')} </span>
              </div>
              <div className="main-menu__controls-value">
                {selectedRestaurant.name}
              </div>
            </NavLink>
            <NavLink to="#"
               onClick={() => this.selectMenu('category')}
               isActive={() => selectedMenu === 'category'}
               className="main-menu__controls-column">
              <div className="main-menu__controls-title">
                <span className="text-uppercase">{t('show')}</span>
              </div>
              <div className="main-menu__controls-value">{this.getTypeName(match.params.type)}</div>
            </NavLink>
          </div>
          <div className={
            classNames('main-menu__items', {
              'main-menu__items--visible': selectedMenu === 'category',
            })}>
            <NavLink
              exact={true}
              to={`/${lng}/${selectedRestaurant.name_for_url}/products/${this.dealsMenu}`}
              className="main-menu__item"
              activeClassName="main-menu__item--active"
              isActive={() => this.checkIsActive(this.dealsMenu)}
              onClick={(e) => this.onClick(e, this.dealsMenu, this.props.selectType)}
            >
              {t('dealsTypeMenu')}
            </NavLink>
            {types.valueSeq().map(type => (
                <NavLink
                  exact={true}
                  to={`/${lng}/${selectedRestaurant.name_for_url}/products/${type.name}`}
                  key={type.id}
                  className="main-menu__item"
                  activeClassName="main-menu__item--active"
                  isActive={() => this.checkIsActive(type.name)}
                  onClick={(e) => this.onClick(e, type.name, this.props.selectType)}
                >
                  {this.getTypeName(type.name)}
                </NavLink>
            ))}
            <button onClick={() => this.selectMenu('')} className="main-menu__close">
            </button>
            {/*<div className="main-menu__text">{t('discount')}</div>*/}
          </div>
          <div className={
            classNames('main-menu__form-wrapper', {
              'main-menu__form-wrapper--visible': selectedMenu === 'restaurant',
            })}>
            <div className="main-menu__form">
              <div className="main-menu__form-input">
              <span className="icon icon-location">
              </span>
                <div className="main-menu__select-wrapper">
                  <Select
                    name="form-takeAway"
                    clearable={false}
                    value='1'
                    className="Select--has-background"
                    options={[{value: 1, label: t('takeAway')}]}
                    searchable={false}
                  />
                </div>
                <span className="text">{t('for')}</span>
              </div>
              <div className="main-menu__form-input">
                <div className="main-menu__select-wrapper main-menu__select-wrapper--wide">
                  <RestaurantLayout
                    classes='Select--has-background'
                  />
                </div>
              </div>
              {selectedMenu === 'restaurant' &&
                <PickUpTimeLayout
                  classNames='main-menu__form-input'
                />
              }
            </div>
          </div>
        </nav>
    );
  }
}

ProductTypeView.propTypes = {
  selectedRestaurant: PropTypes.object,
  changeRestaurant: PropTypes.func,
  language: PropTypes.string,
  types: PropTypes.object,
  selectType: PropTypes.func,
  selectCategory: PropTypes.func,
};

export default withRouter(
    translate('translations')(onClickOutside(ProductTypeView, clickOutsideConfig)));


// WEBPACK FOOTER //
// ./src/components/Product/ProductTypeView.js